import { render } from "./CreateTestModal.vue?vue&type=template&id=a0a2d51c&scoped=true"
import script from "./CreateTestModal.vue?vue&type=script&lang=js"
export * from "./CreateTestModal.vue?vue&type=script&lang=js"

import "./CreateTestModal.vue?vue&type=style&index=0&id=a0a2d51c&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a2d51c"]])

export default __exports__